var _defs, _defs2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnavailable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 3710 3710",
    style: {
      enableBackground: "new 0 0 3710 3710"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Background"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#FFFFFF"
    },
    width: 3710,
    height: 3710
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Order_closed"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4F7FA"
    },
    d: "M3196.76,1610.07c-67.924-444.594-346.411-990.808-896.594-1047.97 c0,0-417.725-50.81-829.51,26.198c-244.395,45.704-458.693,181.754-594.292,377.293 c-135.601,195.539-180.895,433.971-125.924,661.287c35.703,147.644,59.83,300.45,53.208,452.162 c-11.523,264.042-4.894,510.506,251.353,667.973c228.799,140.601,516.745,264.605,791.45,286.325 c186.688,14.76,396.046-9.125,575.978-57.729C3339.4,2727.905,3264.684,2054.663,3196.76,1610.07z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 5943.8076,
    y1: 491.0267,
    x2: 6748.4458,
    y2: 491.0267,
    gradientTransform: "matrix(0.7582 0.6521 -0.6521 0.7582 -2274.8401 -2506.7156)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9085"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FB6FBB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    d: "M1943.147,2559.742c-77.905,21.568-138.563-68.198-89.472-132.42 c15.241-19.939,29.71-41.434,43.033-64.598c98.948-172.033,47.807-284.974,136.92-596.392 c56.345-196.907,97.651-333.756,216.639-382.04c93.245-37.837,223.032-16.756,286.183,56.775 c52.508,61.139,65.096,165.698,58.951,236.442c-5.008,57.656-22.725,95.899,1.657,133.218 c24.918,38.139,64.412,30.329,89.199,60.205c50.268,60.589-23.572,199.487-35.506,221.936 c-132.753,249.714-424.245,366.203-552.007,415.484C2055.694,2524.957,2003.632,2542.996,1943.147,2559.742z"
  }), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000020380608814099618150000013344972382866269587_",
    d: "M1918.086,2566.474 c-71.125,18.524-124.949-65.023-78.22-121.753c20.334-24.686,39.552-51.936,56.842-81.997 c98.948-172.033,47.807-284.974,136.92-596.392c56.345-196.907,97.651-333.756,216.639-382.04 c93.245-37.837,223.032-16.756,286.183,56.775c52.508,61.139,65.096,165.698,58.951,236.442 c-5.008,57.656-22.725,95.899,1.657,133.218c24.918,38.139,64.412,30.329,89.199,60.205 c50.268,60.589-23.572,199.487-35.506,221.936c-132.753,249.714-424.245,366.203-552.007,415.484 C2049.858,2527.208,1989.351,2547.913,1918.086,2566.474z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000039840742747684061670000015950672027995205295_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000020380608814099618150000013344972382866269587_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5,
      clipPath: "url(#SVGID_00000039840742747684061670000015950672027995205295_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1540.26,2646.705l-0.754-6.727c124.883-13.979,236.014-40.354,330.306-78.392 c138.978-56.064,237.105-136.124,291.655-237.954c42.734-79.775,58.028-169.924,79.195-294.696 c16.9-99.609,19.893-171.739,22.535-235.377c3.454-83.238,6.183-148.984,38.706-237.063 c32.995-89.37,86.716-172.831,159.668-248.069l4.859,4.714c-72.291,74.556-125.509,157.222-158.177,245.699 c-32.152,87.081-34.861,152.358-38.291,235.001c-2.651,63.839-5.653,136.196-22.625,236.23 c-20.474,120.685-36.646,216.01-79.903,296.759c-55.317,103.267-154.599,184.363-295.088,241.037 C1777.483,2606.131,1665.754,2632.657,1540.26,2646.705z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2255.749,1960.183l-3.013-2.354c-0.577-0.45-58.193-45.973-105.958-129.519 c-44.084-77.106-88.664-203.367-50.694-366.994l6.595,1.531c-37.473,161.49,6.494,286.048,49.977,362.103 c40.944,71.614,89.03,114.751,101.29,125.109c98.689-162.57,221.804-248.813,307.976-292.587 c94.11-47.808,165.884-56.735,166.598-56.819l0.797,6.724c-0.704,0.083-71.52,8.93-164.617,56.277 c-85.887,43.681-208.863,130.013-306.981,293.251L2255.749,1960.183z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2201.933,2227.862l-0.84-2.312c-0.397-1.099-40.521-111.047-102.315-213.383 c-61.396-101.677-246.638-179.186-248.503-179.957l2.588-6.258c1.884,0.78,189.161,79.129,251.709,182.714 c57.15,94.646,95.856,195.738,102.024,212.248c217.753-10.386,554.527-427.228,557.915-431.453l5.282,4.235 c-0.854,1.066-86.722,107.736-198.597,213.934c-150.583,142.94-273.994,217.01-366.807,220.15L2201.933,2227.862z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2039.718,2559.184c-75.445,0-123.668-6.294-124.357-6.386l-6.687-0.896l4.715-4.825 c74.589-76.316,91.246-172.322,49.512-285.354c-31.243-84.618-85.256-147.374-85.798-147.997l5.111-4.439 c0.55,0.633,55.371,64.328,87.038,150.091c41.225,111.652,25.197,210.896-46.299,287.488 c24.496,2.648,113.951,10.601,230.906,0.765c126.534-10.649,312.052-44.911,477.285-147.662l321.081-199.67l3.577,5.749 l-321.083,199.67c-166.433,103.498-353.146,137.976-480.47,148.673C2111.906,2557.95,2073.141,2559.184,2039.718,2559.184z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000163780200387180478750000001444173043671362492_",
    d: "M1784.974,2567.665 c108.172,63.364,255.013,128.651,422.199,145.147c42.666,4.21,306.237,30.217,336.457-79.23 c10.645-38.553-16.654-61.354-3.323-113.148c15.797-61.372,64.237-68.641,125.269-121.285 c36.417-31.412,142.994-123.339,110.789-226.843c-19.245-61.851-87.177-125.038-154.82-145.502 c-99.218-30.017-178.369,37.761-310.313,154.76c-116.963,103.715-124.128,141.6-209.655,214.815 C2038.101,2450.716,1938.501,2518.488,1784.974,2567.665z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000058577847724457959690000011413702702166370725_",
    gradientUnits: "userSpaceOnUse",
    x1: 2452.3013,
    y1: 1949.8739,
    x2: 2213.7383,
    y2: 2590.228
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA80F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#6165D7"
    }
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000163780200387180478750000001444173043671362492_",
    style: {
      overflow: "visible",
      fill: "url(#SVGID_00000058577847724457959690000011413702702166370725_)"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000119838671986706926760000006812714401226653620_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000163780200387180478750000001444173043671362492_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5,
      clipPath: "url(#SVGID_00000119838671986706926760000006812714401226653620_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1840.568,2569.123c-67.63,0-133.914-9.51-198.615-28.564 c-125.448-36.946-240.438-106.852-341.781-207.78l4.777-4.796c100.535,100.123,214.563,169.459,338.917,206.081 c165.641,48.78,342.015,34.409,524.229-42.711c189.837-80.345,338.448-208.655,429.689-302.143 c63.098-64.652,107.781-150.776,132.81-255.978l6.585,1.567c-25.315,106.412-70.584,193.599-134.548,259.139 c-91.676,93.935-241.022,222.865-431.897,303.651C2058.133,2545.243,1947.682,2569.123,1840.568,2569.123z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2397.938,2366.754l-0.478-3.005c-0.35-2.213-33.485-222.979,106.754-364.471l4.81,4.767 c-128.924,130.074-108.706,328.812-105.29,355.63c315.652-17.181,411.793-189.199,433.788-241.655 c0.617-1.468,1.023-2.377,1.207-2.689l5.831,3.441l-2.916-1.72l2.954,1.653c-0.154,0.297-0.421,0.954-0.831,1.934 c-22.452,53.547-120.737,229.535-442.791,245.96L2397.938,2366.754z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2485.049,2621.086c-0.375,0-0.742,0-1.119-0.001c-70.971-0.215-182.96-22.13-313.444-125.314 l-1.42-1.122l0.145-1.803c0.136-1.689,14.945-170.92,133.152-344.393l119.066-174.74l5.593,3.811l-119.066,174.74 c-110.639,162.371-129.912,320.829-131.825,339.339c71.242,56.052,182.031,122.333,307.818,122.713 c0.355,0.002,0.719,0.002,1.073,0.002c74.835,0,119.876-23.715,120.324-23.955l3.203,5.963 C2606.657,2597.342,2561.533,2621.086,2485.049,2621.086z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000164500902693388200110000016438598178884557493_",
    gradientUnits: "userSpaceOnUse",
    x1: 2885.1404,
    y1: 1181.5176,
    x2: 2526.7883,
    y2: 1080.1115
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#311944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A03976"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000164500902693388200110000016438598178884557493_)"
    },
    d: "M2608.152,1155.696 c11.476,5.827,25.894,0.477,32.204-11.95c6.309-12.426,2.12-27.224-9.356-33.051c-0.594-0.302-1.201-0.556-1.81-0.798 c2.132-6.876,3.74-13.806,4.818-20.738c0.658-0.002,1.318-0.013,1.989-0.073c13.094-1.167,23.485-13.198,23.211-26.874 c-0.274-13.675-11.111-23.815-24.204-22.648c-0.685,0.061-1.357,0.169-2.025,0.288c-1.368-6.777-3.242-13.397-5.606-19.804 c0.602-0.352,1.201-0.717,1.787-1.127c11.202-7.848,14.784-23.338,7.999-34.597c-6.784-11.259-21.365-14.024-32.567-6.177 c-0.574,0.402-1.114,0.837-1.647,1.278c-4.425-4.891-9.277-9.424-14.528-13.561c0.369-0.605,0.73-1.218,1.057-1.862 c6.309-12.427,14.554-26.001,2.988-31.647c-26.756-13.062-38.238-1.88-44.547,10.546c-0.327,0.644-0.608,1.297-0.879,1.952 c-6.438-1.798-12.961-3.041-19.521-3.726c0.042-0.691,0.073-1.383,0.059-2.084c-0.275-13.675,3.783-21.075-9.36-21.331 c-28.66-0.557-38.33,11.883-38.056,25.557c0.014,0.715,0.074,1.414,0.145,2.108c-6.568,1.872-13.018,4.266-19.297,7.161 c-0.299-0.61-0.608-1.216-0.962-1.805c-6.784-11.259-21.365-14.024-32.567-6.176c-11.202,7.849-14.783,23.338-7.999,34.597 c0.347,0.577,0.729,1.116,1.115,1.648c-4.961,4.961-9.607,10.348-13.9,16.128c-0.555-0.348-1.118-0.689-1.713-0.99 c-11.476-5.827-25.894-0.477-32.204,11.95c-6.309,12.427-2.12,27.224,9.356,33.051c0.594,0.302,1.202,0.556,1.81,0.799 c-2.132,6.876-3.74,13.806-4.818,20.738c-0.658,0.002-1.318,0.013-1.988,0.072c-13.094,1.168-23.486,13.199-23.211,26.875 s11.111,23.815,24.204,22.647c0.684-0.061,1.356-0.169,2.025-0.288c1.368,6.777,3.241,13.397,5.606,19.804 c-0.602,0.353-1.202,0.717-1.787,1.127c-11.202,7.848-14.783,23.338-7.999,34.597c6.784,11.26,29.244,16.49,40.446,8.642 c0.574-0.402-6.765-3.302-6.231-3.743c4.425,4.891,9.277,9.424,14.528,13.561c-0.369,0.605-0.73,1.218-1.057,1.862 c-6.309,12.426-2.12,27.224,9.356,33.05s25.894,0.477,32.204-11.95c0.327-0.644,0.608-1.298,0.879-1.953 c6.438,1.797,12.961,3.04,19.521,3.726c-0.041,0.691-0.073,1.383-0.059,2.084c0.274,13.675,11.111,23.815,24.204,22.647 s23.486-13.199,23.211-26.874c-0.014-0.714-0.074-1.414-0.145-2.108c6.568-1.872,13.018-4.266,19.296-7.161 c0.298,0.61,0.608,1.216,0.963,1.804c6.784,11.259,21.365,14.025,32.567,6.177c11.202-7.849,14.784-23.338,8-34.598 c-0.348-0.576-0.728-1.116-1.115-1.648c4.961-4.961,9.606-10.349,13.899-16.127 C2606.995,1155.054,2607.558,1155.394,2608.152,1155.696z M2465.088,1157.511c-41.668-21.156-56.876-74.881-33.969-119.999 c22.907-45.118,75.256-64.543,116.924-43.387c41.668,21.156,56.876,74.881,33.969,119.999 C2559.105,1159.242,2506.757,1178.667,2465.088,1157.511z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000008841994502737178210000007370456435266044546_",
    gradientUnits: "userSpaceOnUse",
    x1: 2884.2009,
    y1: 1184.8364,
    x2: 2525.8479,
    y2: 1083.4301
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#311944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A03976"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000008841994502737178210000007370456435266044546_)"
    },
    d: "M2635.996,1089.086 c13.094-1.167,23.485-13.199,23.211-26.874c-0.274-13.675-11.111-23.815-24.204-22.648c-0.685,0.061-1.357,0.169-2.025,0.288 c-1.367-6.777-3.242-13.397-5.606-19.804c0.602-0.352,1.201-0.717,1.787-1.127c11.202-7.848,25.061-26.811,17.157-37.315 c-15-19.935-30.523-11.306-41.725-3.458c-0.574,0.402-1.114,0.836-1.647,1.277c-4.425-4.891-9.278-9.423-14.528-13.56 c0.369-0.605,0.73-1.218,1.057-1.862c3.434-6.763,3.737-14.22,1.469-20.559c-10.82,19.044-21.494,38.167-31.977,57.395 c33.241,24.359,43.824,72.361,23.046,113.286c-17.608,34.68-52.608,54.153-86.783,51.713c-1.525,3.953-3.021,7.929-4.654,11.844 c-4.43,10.626-9.463,21.033-14.502,31.426c3.169,0.597,6.352,1.068,9.544,1.402c-0.041,0.691-0.073,1.383-0.059,2.084 c0.274,13.675,8.577,25.294,32.307,24.035c13.127-0.696,15.383-14.586,15.109-28.262c-0.014-0.714-0.074-1.413-0.145-2.107 c6.568-1.872,13.018-4.266,19.296-7.161c0.298,0.61,0.608,1.216,0.963,1.805c6.784,11.26,30.319,16.044,41.521,8.195 c11.202-7.849,5.829-25.357-0.955-36.616c-0.348-0.577-0.728-1.116-1.115-1.648c4.961-4.961,9.607-10.348,13.899-16.127 c0.555,0.348,1.118,0.689,1.713,0.99c11.476,5.827,25.894,0.477,32.204-11.95c6.309-12.426,2.12-27.224-9.356-33.05 c-0.595-0.302-1.202-0.556-1.81-0.798c2.132-6.876,3.74-13.806,4.818-20.738 C2634.665,1089.157,2635.325,1089.146,2635.996,1089.086z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000013157775077731526660000017505965200911404676_",
    gradientUnits: "userSpaceOnUse",
    x1: 2517.3967,
    y1: 955.0585,
    x2: 2523.0005,
    y2: 1407.5779
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9085"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FB6FBB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000013157775077731526660000017505965200911404676_)"
    },
    d: "M2620.495,1157.1 c11.476,5.827,25.894,0.476,32.204-11.95s2.121-27.224-9.356-33.05c-0.594-0.302-1.201-0.556-1.81-0.798 c2.132-6.876,3.74-13.806,4.818-20.739c0.658-0.002,1.318-0.013,1.989-0.073c13.093-1.167,23.485-13.199,23.211-26.874 c-0.274-13.676-11.111-23.815-24.204-22.648c-0.684,0.061-1.356,0.169-2.025,0.288c-1.367-6.777-3.241-13.397-5.605-19.804 c0.602-0.352,1.201-0.717,1.787-1.127c11.202-7.848,14.784-23.338,7.999-34.597c-6.784-11.259-21.365-14.025-32.567-6.176 c-0.574,0.402-1.114,0.837-1.648,1.277c-4.424-4.891-9.277-9.424-14.527-13.561c0.369-0.605,0.73-1.219,1.057-1.862 c6.309-12.426,2.121-27.224-9.355-33.05c-11.477-5.827-25.895-0.477-32.204,11.95c-0.327,0.644-0.609,1.298-0.879,1.953 c-6.438-1.798-12.961-3.04-19.521-3.727c0.041-0.691,0.073-1.383,0.059-2.084c-0.275-13.675-11.111-23.815-24.205-22.648 c-13.094,1.167-23.485,13.199-23.211,26.874c0.014,0.715,0.074,1.413,0.145,2.108c-6.568,1.872-13.018,4.266-19.297,7.161 c-0.298-0.61-0.608-1.216-0.962-1.805c-6.784-11.259-21.365-14.024-32.567-6.176c-11.202,7.849-14.783,23.338-7.999,34.597 c0.348,0.577,0.729,1.116,1.115,1.648c-4.961,4.961-9.607,10.348-13.9,16.127c-0.555-0.348-1.118-0.688-1.713-0.99 c-11.476-5.827-25.894-0.477-32.203,11.95s-2.121,27.224,9.356,33.051c0.594,0.302,1.202,0.556,1.81,0.798 c-2.132,6.876-3.74,13.806-4.818,20.738c-0.658,0.002-1.318,0.013-1.989,0.072c-13.094,1.168-23.485,13.199-23.211,26.875 c0.274,13.675,11.111,23.814,24.204,22.647c0.684-0.061,1.356-0.169,2.024-0.288c1.368,6.777,3.242,13.397,5.606,19.804 c-0.602,0.352-1.202,0.716-1.787,1.127c-11.202,7.848-14.783,23.338-8,34.597c6.784,11.26,21.365,14.024,32.567,6.177 c0.574-0.403,1.114-0.837,1.648-1.278c4.425,4.891,9.277,9.424,14.528,13.561c-0.369,0.605-0.731,1.218-1.057,1.862 c-6.309,12.426-2.12,27.224,9.356,33.051c11.476,5.827,25.894,0.476,32.204-11.95c0.327-0.643,0.608-1.297,0.879-1.952 c6.438,1.798,12.961,3.04,19.521,3.726c-0.041,0.691-0.073,1.383-0.059,2.084c0.274,13.675,11.111,23.815,24.204,22.647 c13.093-1.167,23.485-13.199,23.211-26.874c-0.014-0.715-0.074-1.414-0.145-2.108c6.568-1.872,13.018-4.266,19.296-7.161 c0.298,0.61,0.608,1.216,0.963,1.804c6.784,11.259,21.365,14.025,32.567,6.177c11.202-7.849,14.783-23.338,8-34.598 c-0.348-0.576-0.729-1.116-1.115-1.648c4.961-4.961,9.607-10.348,13.9-16.127 C2619.338,1156.457,2619.901,1156.798,2620.495,1157.1z M2477.432,1158.915c-41.668-21.156-56.877-74.881-33.969-119.999 c22.907-45.118,75.256-64.543,116.924-43.387c41.668,21.156,56.876,74.881,33.969,119.999 C2571.448,1160.646,2519.1,1180.07,2477.432,1158.915z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000139978598872811757060000010887818787713768377_",
    gradientUnits: "userSpaceOnUse",
    x1: 2843.7385,
    y1: 971.7992,
    x2: 2141.7676,
    y2: 773.1561
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#311944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A03976"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000139978598872811757060000010887818787713768377_)"
    },
    d: "M2301.15,921.218 c22.481,11.414,50.724,0.934,63.083-23.408c12.359-24.342,4.153-53.329-18.327-64.742c-1.165-0.592-2.353-1.088-3.546-1.564 c4.177-13.469,7.326-27.044,9.438-40.624c1.289-0.004,2.582-0.025,3.896-0.142c25.648-2.287,46.005-25.855,45.468-52.643 c-0.537-26.788-21.765-46.652-47.413-44.365c-1.341,0.12-2.657,0.332-3.967,0.565c-2.679-13.275-6.35-26.243-10.981-38.794 c1.18-0.69,2.354-1.404,3.5-2.207c21.943-15.373,28.959-45.716,15.67-67.772c-13.289-22.056-41.852-27.473-63.795-12.099 c-1.125,0.788-2.182,1.639-3.228,2.503c-8.667-9.581-18.173-18.461-28.458-26.564c0.723-1.186,1.431-2.386,2.071-3.648 c12.359-24.342,28.509-50.932,5.852-61.993c-52.412-25.586-74.903-3.684-87.263,20.659c-0.64,1.261-1.192,2.542-1.722,3.824 c-12.611-3.521-25.389-5.956-38.239-7.299c0.081-1.353,0.143-2.709,0.116-4.082c-0.538-26.787,7.411-41.284-18.335-41.784 c-56.142-1.092-75.084,23.277-74.547,50.063c0.028,1.4,0.145,2.769,0.283,4.129c-12.865,3.667-25.501,8.356-37.8,14.027 c-0.584-1.195-1.191-2.382-1.885-3.536c-13.289-22.056-41.852-27.472-63.796-12.098c-21.944,15.374-28.959,45.716-15.67,67.772 c0.68,1.13,1.427,2.187,2.184,3.229c-9.718,9.719-18.818,20.272-27.227,31.592c-1.088-0.682-2.191-1.349-3.355-1.94 c-22.481-11.414-50.724-0.934-63.083,23.408c-12.359,24.342-4.153,53.328,18.327,64.742c1.165,0.591,2.354,1.088,3.546,1.564 c-4.177,13.469-7.326,27.044-9.438,40.624c-1.289,0.004-2.582,0.025-3.895,0.141c-25.649,2.288-46.005,25.856-45.469,52.645 c0.537,26.788,21.765,46.65,47.414,44.364c1.34-0.119,2.657-0.33,3.966-0.563c2.679,13.276,6.349,26.243,10.981,38.795 c-1.18,0.69-2.354,1.404-3.5,2.207c-21.944,15.373-28.959,45.716-15.67,67.772c13.289,22.056,57.286,32.303,79.229,16.929 c1.125-0.788-13.252-6.469-12.207-7.332c8.668,9.581,18.173,18.46,28.458,26.564c-0.722,1.185-1.431,2.386-2.071,3.648 c-12.359,24.342-4.153,53.328,18.327,64.742c22.481,11.414,50.724,0.933,63.083-23.408c0.64-1.261,1.192-2.542,1.723-3.825 c12.611,3.521,25.389,5.956,38.239,7.3c-0.08,1.353-0.143,2.709-0.115,4.082c0.537,26.787,21.765,46.65,47.413,44.364 s46.006-25.856,45.468-52.643c-0.028-1.4-0.145-2.769-0.284-4.129c12.866-3.667,25.501-8.356,37.8-14.027 c0.584,1.195,1.191,2.382,1.885,3.534c13.29,22.056,41.851,27.473,63.795,12.099c21.944-15.374,28.959-45.716,15.67-67.773 c-0.681-1.129-1.427-2.185-2.184-3.228c9.717-9.719,18.818-20.272,27.228-31.592 C2298.883,919.96,2299.985,920.626,2301.15,921.218z M2020.905,924.773c-81.623-41.442-111.415-146.683-66.541-235.064 c44.873-88.382,147.418-126.433,229.04-84.991c81.623,41.442,111.415,146.684,66.542,235.064 C2205.073,928.164,2102.528,966.215,2020.905,924.773z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000173130846204929855210000013175280445169632642_",
    gradientUnits: "userSpaceOnUse",
    x1: 2841.8977,
    y1: 978.3002,
    x2: 2139.9258,
    y2: 779.6567
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#311944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A03976"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000173130846204929855210000013175280445169632642_)"
    },
    d: "M2355.694,790.737 c25.648-2.287,46.005-25.856,45.468-52.644c-0.537-26.788-21.765-46.651-47.413-44.364c-1.341,0.119-2.657,0.332-3.967,0.564 c-2.678-13.276-6.35-26.243-10.981-38.794c1.18-0.689,2.354-1.404,3.5-2.208c21.943-15.373,49.091-52.52,33.61-73.096 c-29.384-39.052-59.792-22.148-81.735-6.775c-1.125,0.788-2.182,1.638-3.227,2.502c-8.668-9.581-18.173-18.46-28.458-26.564 c0.723-1.186,1.431-2.386,2.071-3.646c6.727-13.249,7.32-27.855,2.878-40.273c-21.195,37.304-42.104,74.765-62.639,112.43 c65.116,47.716,85.847,141.748,45.145,221.915c-34.491,67.934-103.053,106.079-169.999,101.299 c-2.986,7.745-5.918,15.531-9.116,23.201c-8.678,20.815-18.536,41.2-28.408,61.559c6.208,1.17,12.443,2.092,18.696,2.746 c-0.08,1.354-0.143,2.71-0.115,4.083c0.537,26.788,16.801,49.548,63.285,47.082c25.714-1.364,30.134-28.573,29.596-55.361 c-0.028-1.4-0.145-2.769-0.283-4.129c12.865-3.667,25.501-8.356,37.799-14.027c0.584,1.195,1.191,2.382,1.886,3.534 c13.289,22.057,59.391,31.428,81.335,16.053s11.419-49.67-1.87-71.727c-0.681-1.13-1.427-2.186-2.184-3.229 c9.717-9.718,18.818-20.271,27.227-31.591c1.088,0.683,2.19,1.349,3.355,1.939c22.481,11.415,50.724,0.934,63.083-23.408 c12.359-24.341,4.154-53.328-18.327-64.742c-1.165-0.591-2.353-1.089-3.546-1.564c4.177-13.469,7.326-27.045,9.438-40.623 C2353.086,790.875,2354.38,790.853,2355.694,790.737z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000079466525583375615730000000631954177193926797_",
    gradientUnits: "userSpaceOnUse",
    x1: 2123.3704,
    y1: 528.1912,
    x2: 2134.3477,
    y2: 1414.6256
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9085"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FB6FBB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000079466525583375615730000000631954177193926797_)"
    },
    d: "M2325.329,923.967 c22.48,11.414,50.724,0.934,63.083-23.409c12.359-24.342,4.154-53.328-18.327-64.742c-1.165-0.591-2.353-1.089-3.545-1.563 c4.177-13.469,7.325-27.044,9.437-40.625c1.289-0.003,2.582-0.025,3.896-0.142c25.648-2.286,46.004-25.855,45.468-52.643 c-0.537-26.789-21.764-46.651-47.413-44.365c-1.341,0.12-2.657,0.332-3.967,0.565c-2.679-13.276-6.35-26.243-10.981-38.794 c1.18-0.69,2.354-1.404,3.501-2.207c21.943-15.373,28.959-45.716,15.67-67.773c-13.289-22.056-41.852-27.472-63.795-12.099 c-1.125,0.788-2.183,1.639-3.228,2.502c-8.667-9.581-18.173-18.46-28.457-26.563c0.723-1.186,1.431-2.387,2.071-3.648 c12.359-24.342,4.154-53.329-18.327-64.742c-22.481-11.414-50.724-0.934-63.083,23.408c-0.64,1.261-1.192,2.542-1.723,3.825 c-12.611-3.521-25.389-5.956-38.238-7.299c0.08-1.354,0.142-2.709,0.115-4.082c-0.538-26.787-21.765-46.65-47.414-44.364 c-25.649,2.286-46.005,25.856-45.468,52.643c0.028,1.401,0.145,2.769,0.284,4.129c-12.866,3.668-25.501,8.356-37.8,14.028 c-0.584-1.195-1.191-2.382-1.885-3.536c-13.289-22.056-41.852-27.473-63.796-12.098c-21.944,15.375-28.959,45.717-15.67,67.772 c0.681,1.13,1.427,2.187,2.184,3.229c-9.717,9.719-18.818,20.271-27.228,31.592c-1.087-0.682-2.19-1.349-3.355-1.94 c-22.481-11.414-50.724-0.934-63.083,23.408c-12.359,24.342-4.154,53.328,18.327,64.742c1.165,0.591,2.354,1.088,3.546,1.564 c-4.177,13.469-7.326,27.044-9.438,40.624c-1.289,0.004-2.582,0.025-3.895,0.141c-25.649,2.288-46.005,25.856-45.468,52.645 c0.537,26.788,21.765,46.65,47.414,44.364c1.34-0.119,2.657-0.33,3.966-0.563c2.679,13.276,6.35,26.243,10.981,38.794 c-1.18,0.69-2.354,1.404-3.5,2.208c-21.944,15.373-28.959,45.716-15.67,67.772c13.289,22.056,41.852,27.472,63.795,12.099 c1.125-0.789,2.183-1.639,3.228-2.503c8.668,9.581,18.173,18.461,28.458,26.564c-0.722,1.185-1.431,2.386-2.071,3.647 c-12.359,24.342-4.153,53.328,18.327,64.742c22.481,11.414,50.724,0.934,63.083-23.409c0.64-1.26,1.192-2.541,1.723-3.824 c12.611,3.521,25.389,5.955,38.239,7.299c-0.08,1.353-0.143,2.709-0.115,4.083c0.537,26.787,21.765,46.65,47.413,44.364 c25.648-2.286,46.005-25.856,45.468-52.643c-0.028-1.4-0.145-2.769-0.284-4.128c12.866-3.667,25.501-8.356,37.8-14.027 c0.584,1.194,1.191,2.382,1.886,3.534c13.289,22.056,41.851,27.474,63.795,12.099c21.944-15.374,28.959-45.716,15.671-67.774 c-0.681-1.129-1.427-2.186-2.185-3.228c9.718-9.718,18.818-20.271,27.228-31.591 C2323.062,922.709,2324.165,923.375,2325.329,923.967z M2045.084,927.523c-81.623-41.442-111.415-146.683-66.542-235.065 c44.873-88.381,147.417-126.432,229.04-84.99c81.623,41.442,111.415,146.683,66.542,235.064 C2229.252,930.914,2126.708,968.964,2045.084,927.523z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BFC8D6"
    },
    d: "M3213.094,2867.989l-2663.763-23.025v68.128c0,18.491,11.618,34.214,27.353,37.016 l753.233,134.155c8.939,1.592,18.004,2.014,27.024,1.259l1827.206-152.958c16.313-1.365,28.947-17.137,28.947-36.136V2867.989z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BFC8D6"
    },
    d: "M2278.146,1564.289v1139.705c0,14.377-5.236,27.793-13.61,37.745 c-8.133,9.745-19.329,16.162-31.681,17.088l-1224.002,90.282l-456.363,33.768h-0.069l-3.09,0.065l-9.916,0.6 c-30.299,2.23-55.314-21.569-55.314-53.034V1569.744c0-31.466,25.392-57.788,55.691-57.788H2232.81 C2257.79,1511.956,2278.146,1535.843,2278.146,1564.289z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2305.226,1564.289v1139.705c0,21.964-12.192,41.575-29.175,50.209 c-0.25,0.127-0.563,0.253-0.814,0.375c-1.618,0.786-3.294,1.508-4.993,2.086c-0.377,0.137-0.771,0.275-1.148,0.412 c-0.308,0.069-0.626,0.173-0.899,0.24c-1.236,0.379-2.475,0.654-3.745,0.893c-1.51,0.308-3.055,0.514-4.633,0.618l-8.58,0.56 l-1218.217,89.64h-0.067l-466.191,34.371c-4.494,0.344-8.887,0.305-13.072-0.484c-0.412-0.069-0.791-0.037-1.201-0.037h-0.069 c-1.03,0-2.399-0.62-3.429-0.928c-21.755-5.938-37.81-26.289-37.81-51.441V1569.744c0-31.466,25.318-57.788,55.617-57.788 h1693.018C2284.796,1511.956,2305.226,1535.843,2305.226,1564.289z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8DEE8"
    },
    d: "M2207.078,2678.461L630.192,2786.719c-24.654,1.692-44.689-17.758-44.689-43.448V1639.478 c0-25.69,20.035-46.603,44.689-46.709l1576.886-6.798c20.59-0.089,37.244,18.808,37.244,42.207v1005.358 C2244.322,2656.935,2227.668,2677.048,2207.078,2678.461z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1473.096,1547.256c0,11.715-8.714,21.239-19.475,21.273 c-10.774,0.035-19.517-9.456-19.517-21.197s8.743-21.265,19.517-21.274C1464.382,1526.051,1473.096,1535.541,1473.096,1547.256 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.48,
      fill: "#FFFFFF"
    },
    d: "M566.779,2883.443l1684.471-124.001l8.572-0.631 c11.452-0.843,21.865-6.504,29.819-15.091c-121.217-6.634-196.506-49.65-245.073-94.098 c-97.533-89.262-80.616-177.287-185.795-235.975c-131.186-73.202-234.337,19.553-333.886-71.963 c-60.351-55.484-30.722-96.859-104.984-179.772c-82.251-91.834-135.802-60.964-218.463-143.615 c-104.518-104.507-52.245-185.816-142.276-260.848c-109.22-91.026-227.008-6.776-330.977-94.072 c-44.843-37.651-69.449-92.389-82.297-150.604h-79.103c-30.296,0-54.929,25.511-54.929,56.979v1260.756 C511.856,2861.973,536.484,2885.669,566.779,2883.443z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000041262918902201981670000011653142435264346257_",
    gradientUnits: "userSpaceOnUse",
    x1: 1171.557,
    y1: 2887.6338,
    x2: 3835.3201,
    y2: 2887.6338
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.494,
    style: {
      stopColor: "#EBEFF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000041262918902201981670000011653142435264346257_)"
    },
    d: "M2339.59,2751.898L549.331,2883.085 l780.586,139.027c8.939,1.592,18.004,2.015,27.024,1.26l1856.153-155.382l-845.027-115.199 C2358.618,2751.501,2349.086,2751.203,2339.59,2751.898z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8DEE8"
    },
    points: "810.558,2884.213 2301.001,2773.369 2762.281,2835.747 1284.676,2954.234  "
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#BFC8D6"
    },
    d: "M2169.826,1511.956v1138.026c0,10.5-2.102,20.761-5.156,30.47 c-4.289,13.761-11.654,26.423-20.918,37.3c-17.844,20.932-43.693,35.172-72.516,37.368l-1225.855,92.51l-72.294,5.456 c-17.432,1.339-33.951-1.064-48.741-6.484c-29.715-10.81-51.827-33.766-60.645-63.071c-2.676-8.749-3.581-18.048-3.581-27.794 V1511.956H2169.826z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000062160390285172721120000018036623963901978032_",
    gradientUnits: "userSpaceOnUse",
    x1: 685.9622,
    y1: 1804.2212,
    x2: 2196.96,
    y2: 1804.2212
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    style: {
      stopColor: "#E38DDD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9571F6"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000062160390285172721120000018036623963901978032_)"
    },
    d: "M2098.708,819.081L800.199,779.073 c-62.924-1.939-114.237,43.923-114.237,102.445v1850.212c0,58.523,51.312,102.094,114.237,97.346l1298.509-97.973 c54.396-4.104,98.252-51.161,98.252-105.128V919.823C2196.96,865.857,2153.105,820.757,2098.708,819.081z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.74,
      fill: "#FFFFFF"
    },
    d: "M722.585,2740.177V871.436c0-33.68,29.507-60.125,65.783-59.07l1320.62,38.387 c31.368,0.912,56.717,26.918,56.717,58.089v1729.511c0,31.17-25.348,58.308-56.717,60.62l-1320.62,97.339 C752.093,2798.985,722.585,2773.857,722.585,2740.177z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000136374312340225104390000002498033999486908050_",
    gradientUnits: "userSpaceOnUse",
    x1: 1449.4897,
    y1: 860.4185,
    x2: 1320.4358,
    y2: 2026.8733
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#40447E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#3C3B6B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000136374312340225104390000002498033999486908050_)"
    },
    d: "M2098.709,819.081l-1298.51-40.009 c-62.923-1.939-114.237,43.922-114.237,102.445v76.013l1510.998,32.386v-70.095 C2196.96,865.857,2153.105,820.757,2098.709,819.081z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M888.807,876.502c0,18.954-16.502,33.921-36.898,33.43c-20.439-0.492-37.04-16.317-37.04-35.343 s16.601-33.991,37.04-33.426C872.305,841.727,888.807,857.548,888.807,876.502z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1017.286,879.827c0,18.827-16.282,33.696-36.405,33.212c-20.166-0.486-36.545-16.201-36.545-35.1 c0-18.899,16.379-33.766,36.545-33.208C1001.004,845.287,1017.286,861,1017.286,879.827z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1144.057,883.107c0,18.702-16.066,33.475-35.923,32.997 c-19.898-0.479-36.059-16.087-36.059-34.86c0-18.773,16.161-33.544,36.059-32.993 C1127.99,848.801,1144.057,864.406,1144.057,883.107z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1423.826,1343.953l-534.461-0.848c-8.712-0.014-15.781-6.502-15.781-14.49v-34.005 c0-7.989,7.07-14.426,15.781-14.377l534.461,2.999c8.117,0.046,14.691,6.325,14.691,14.025v32.776 C1438.516,1337.734,1431.943,1343.965,1423.826,1343.953z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M910.09,1355.916l45.949,168.512c2.903,10.651,13.319,18.025,25.251,17.891l355.789-3.997 c11.374-0.128,21.275-7.538,24.033-17.972l43.33-164.055L910.09,1355.916z M1041.983,1514.544 c0,6.686-5.859,12.166-13.089,12.24l-12.489,0.128c-7.248,0.074-13.132-5.299-13.132-12.001v-130.606 c0-6.703,5.884-12.138,13.132-12.14l12.489-0.003c7.23-0.002,13.089,5.416,13.089,12.102V1514.544z M1111.419,1513.885 c0,6.656-5.806,12.111-12.972,12.184l-12.377,0.127c-7.183,0.074-13.014-5.276-13.014-11.948v-130.018 c0-6.672,5.831-12.083,13.014-12.085l12.377-0.003c7.165-0.002,12.972,5.392,12.972,12.048V1513.885z M1180.235,1513.233 c0,6.626-5.755,12.057-12.856,12.13l-12.266,0.126c-7.119,0.073-12.898-5.252-12.898-11.895v-129.435 c0-6.642,5.779-12.029,12.898-12.031l12.266-0.003c7.101-0.002,12.856,5.368,12.856,11.994V1513.233z M1248.438,1512.586 c0,6.596-5.703,12.003-12.742,12.075l-12.157,0.125c-7.056,0.073-12.783-5.229-12.783-11.842v-128.858 c0-6.613,5.727-11.975,12.783-11.977l12.157-0.003c7.038-0.002,12.742,5.344,12.742,11.94V1512.586z M1316.037,1511.945 c0,6.567-5.653,11.949-12.629,12.021l-12.049,0.124c-6.994,0.072-12.67-5.207-12.67-11.79v-128.286 c0-6.583,5.677-11.922,12.67-11.924l12.049-0.003c6.976-0.002,12.629,5.32,12.629,11.888V1511.945z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8DEE8"
    },
    d: "M970.134,1263.538c-8.118,6.464-20.449,5.606-27.542-1.928 c-7.099-7.541-6.25-18.901,1.895-25.36c8.136-6.453,20.463-5.565,27.535,1.973 C979.088,1245.752,978.244,1257.081,970.134,1263.538z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1141.647,1103.421c-2.677-2.908-8.214-2.594-12.367,0.705l-169.23,134.387 c-4.248,3.373-5.47,8.475-2.728,11.392c2.741,2.916,8.403,2.543,12.646-0.831l169.015-134.417 C1143.131,1111.358,1144.323,1106.328,1141.647,1103.421z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8DEE8"
    },
    d: "M1347.715,1266.073c7.72,6.405,19.417,5.72,26.128-1.519 c6.705-7.232,5.904-18.281-1.792-24.689c-7.703-6.415-19.405-5.759-26.134,1.477 C1339.182,1248.584,1339.988,1259.662,1347.715,1266.073z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1180.797,1104.095c2.663-2.808,8.163-2.303,12.285,1.125l164.222,136.598 c4.031,3.353,5.19,8.34,2.589,11.141c-2.601,2.802-7.982,2.357-12.018-0.996l-164.427-136.574 C1179.321,1111.962,1178.134,1106.904,1180.797,1104.095z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "2046.152,1183.277 1495.025,1176.242 1495.025,1107.643 2046.152,1117.196  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "2046.152,1298.97 1495.025,1296.344 1495.025,1227.744 2046.152,1232.889  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "2046.152,1414.663 1495.025,1416.446 1495.025,1347.846 2046.152,1348.582  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "2046.152,1530.355 1495.025,1536.547 1495.025,1467.948 2046.152,1464.274  "
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000109720659640787007500000016532087363728653213_",
    gradientUnits: "userSpaceOnUse",
    x1: 967.4087,
    y1: 2147.1782,
    x2: 1971.1897,
    y2: 2147.1782
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9085"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FB6FBB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000109720659640787007500000016532087363728653213_)"
    },
    d: "M1971.19,2115.181 c0,277.528-223.63,517.457-500.342,535.955c-277.657,18.561-503.439-192.719-503.439-471.964s225.782-519.312,503.439-536.152 C1747.56,1626.236,1971.19,1837.653,1971.19,2115.181z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1501.579,1665.781c120.865,0,233.234,45.952,316.407,129.388 c83.514,83.78,129.507,197.429,129.507,320.012c0,128.246-49.732,252.17-140.033,348.948 c-90.33,96.806-210.436,154.823-338.195,163.364c-10.745,0.719-21.602,1.083-32.273,1.083 c-120.782,0-233.093-45.873-316.247-129.167c-83.602-83.744-129.643-197.473-129.643-320.237 c0-266.502,215.856-496.408,481.178-512.5c9.732-0.59,19.581-0.891,29.293-0.891H1501.579L1501.579,1665.781z  M1501.553,1642.086c-10.147,0-20.404,0.309-30.706,0.934c-277.657,16.841-503.438,256.907-503.438,536.152 c0,267.808,207.655,473.099,469.585,473.099c11.185,0,22.482-0.375,33.853-1.135 c276.713-18.497,500.342-258.428,500.342-535.954C1971.189,1847.987,1763.929,1642.071,1501.553,1642.086L1501.553,1642.086z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1685.194,2413.485c-14.713,1.712-29.496-2.918-40.824-14.338l-393.439-396.597 c-25.807-26.016-25.807-70.101,0-98.078c25.606-27.758,66.693-28.842,91.779-2.803l382.768,397.354 c22.019,22.861,22.019,63.428,0,90.942C1714.409,2403.795,1699.834,2411.781,1685.194,2413.485z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1297.145,2458.629c-16.65,1.937-33.386-2.873-46.215-14.936 c-25.807-24.267-25.807-68.353,0-98.078l393.439-453.158c22.615-26.048,58.925-27.006,81.108-2.477 c22.019,24.348,22.019,64.916,0,90.942l-382.768,452.381C1330.191,2448.097,1313.71,2456.701,1297.145,2458.629z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000005245426954984126560000000805318302123578262_",
    gradientUnits: "userSpaceOnUse",
    x1: -590.7947,
    y1: 1740.7622,
    x2: -265.9546,
    y2: 3298.6179,
    gradientTransform: "matrix(-1 0 0 1 1961.1639 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000005245426954984126560000000805318302123578262_)"
    },
    d: "M2398.869,1789.767 c-32.688-34.9,57.804-166.014,106.238-223.466c42.313-50.191,85.803-101.779,139.208-95.248 c46.889,5.735,92.515,55.183,95.248,102.575C2746.917,1701.12,2445.339,1839.382,2398.869,1789.767z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000165936972731718286360000015016661650030228907_",
    gradientUnits: "userSpaceOnUse",
    x1: 3022.8076,
    y1: 3105.2249,
    x2: 3135.3293,
    y2: 3105.2249,
    gradientTransform: "matrix(0.9996 0.0289 -0.0289 0.9996 -244.5115 -31.2392)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#26264F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000165936972731718286360000015016661650030228907_)"
    },
    d: "M2791.344,3137.084 c6.153,5.001,7.285,17.492,8.023,25.657c0.333,3.647,0.497,5.472,0.089,6.759c-2.973,9.396-21.197,10.385-49.773,13.305 c-45.16,4.614-58.598,8.168-62.133,1.448c-3.312-6.298,4.703-16.61,5.606-17.747c4.852-6.112,10.808-8.336,22.323-12.125 c21.306-7.013,35.701-10.853,40.06-12.015C2782.756,3135.099,2787.302,3133.8,2791.344,3137.084z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000164477645902284484110000015826609390376052616_",
    gradientUnits: "userSpaceOnUse",
    x1: 2759.968,
    y1: 3124.5952,
    x2: 2800.3081,
    y2: 3124.5952
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000164477645902284484110000015826609390376052616_)"
    },
    d: "M2764.487,3095.828l-4.519,51.461 c1.283,2.485,16.579,9.939,28.729,3.547l11.612-50.584L2764.487,3095.828z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000116921871811636623540000010397453281482910602_",
    gradientUnits: "userSpaceOnUse",
    x1: 3373.9307,
    y1: 2638.0605,
    x2: 3493.478,
    y2: 2638.0605,
    gradientTransform: "matrix(0.9642 0.2651 -0.2651 0.9642 -231.6863 -308.9189)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#26264F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000116921871811636623540000010397453281482910602_)"
    },
    d: "M2433.199,3130.47 c7.375,8.144,9.055,23.141,2.643,30.529c-6.304,7.264-15.782,1.816-42.664,2.618c-28.795,0.861-36.314,7.661-55.882,2.262 c-7.905-2.185-21.867-7.485-21.602-13.13c0.186-3.97,7.294-6.02,31.035-13.974c33.699-11.288,33.55-11.905,40.707-13.091 C2405.41,3122.708,2423.459,3119.717,2433.199,3130.47z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000150816513103100409360000014740275274363187076_",
    gradientUnits: "userSpaceOnUse",
    x1: 2400.3071,
    y1: 3111.2769,
    x2: 2450.1306,
    y2: 3111.2769
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000150816513103100409360000014740275274363187076_)"
    },
    d: "M2414.75,3083.506l-14.442,48.041 c1.092,2.577,15.774,11.173,28.374,5.728l21.45-46.629L2414.75,3083.506z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000094583019420567782450000010527087363822051204_",
    gradientUnits: "userSpaceOnUse",
    x1: -400.2105,
    y1: 2934.5444,
    x2: -719.0652,
    y2: 2215.77,
    gradientTransform: "matrix(-1 0 0 1 1961.1639 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#40447E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#3C3B6B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000094583019420567782450000010527087363822051204_)"
    },
    d: "M2543.073,2031.327 c-2.069,161.455-13.086,342.992-39.523,540.222c-26.127,194.931-62.742,371.061-102.683,525.942 c18.427,4.958,36.854,9.915,55.279,14.873c46.75-43.591,105.723-112.211,134.179-209.182 c17.661-60.186,11.775-91.113,22.978-165.141c17.837-117.868,53.969-179.621,91.312-274.669 c33.558-85.411,73.224-210.759,94.492-378.31C2713.763,2067.151,2628.417,2049.239,2543.073,2031.327z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000039845219198832673130000007199714155712479130_",
    gradientUnits: "userSpaceOnUse",
    x1: -985.3562,
    y1: 2760.4705,
    x2: -1304.2053,
    y2: 2041.7086,
    gradientTransform: "matrix(-0.9925 -0.1225 -0.1225 0.9925 1878.1588 108.1241)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#40447E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#3C3B6B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000039845219198832673130000007199714155712479130_)"
    },
    d: "M2709.406,2015.921 c11.278,205.344,20.554,414.51,27.583,627.381c5.276,159.738,9.15,317.45,11.724,473.086c18.822,2.324,37.645,4.649,56.469,6.971 c18.188-33.862,42.344-85.633,58.893-151.989c20.099-80.59,15.445-128.449,24.259-211.974 c9.89-93.68,24.255-114.09,49.703-232.266c51.649-239.834,77.475-359.753,19.859-434.348 C2939.193,2068.566,2880.561,2007.819,2709.406,2015.921z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000070832091372794063160000007272928164013774002_",
    gradientUnits: "userSpaceOnUse",
    x1: -885.7394,
    y1: 1802.2628,
    x2: -560.9005,
    y2: 3360.1128,
    gradientTransform: "matrix(-1 0 0 1 1961.1639 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000070832091372794063160000007272928164013774002_)"
    },
    d: "M2983.729,1499.835 c-44.08-12.396-108.683-26.892-187.802-31.364c-112.844-6.378-169.267-9.567-209.249,17.305 c-92.345,62.066-20.852,205.313-58.652,560.412c-5.398,50.711-6.609,101.782-10.518,152.629 c-6.474,84.188-7.948,88.759-2.089,97.29c36.734,53.496,173.783-27.194,374.658,4.702 c112.393,17.846,163.367,58.962,194.159,29.307c35.909-34.584,5.107-127.604-21.408-207.68 c-30.436-91.915-49.237-93.098-66.513-162.321c-18.057-72.353-7.135-109.607-4.323-223.703 C2993.336,1681.818,2993.05,1600.571,2983.729,1499.835z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000057857322474006120850000008290792935845502593_",
    gradientUnits: "userSpaceOnUse",
    x1: -974.7816,
    y1: 2786.8069,
    x2: -832.1874,
    y2: 2109.4873,
    gradientTransform: "matrix(-1 0 0 1 1961.1639 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000057857322474006120850000008290792935845502593_)"
    },
    d: "M2710.571,2166.485 c52.502-4.108,86.562,25.574,131.882,2.442c62.145-31.72,82.113-130.414,78.153-200.265 c-6.017-106.13-66.619-134.105-56.172-202.707c5.649-37.1,32.137-86.355,127.238-136.677 c1.268,42.353,1.027,78.453,0.32,107.134c-2.812,114.096-13.734,151.35,4.323,223.703 c17.276,69.223,36.078,70.406,66.513,162.321c26.515,80.076,57.317,173.096,21.408,207.68 c-30.792,29.656-81.766-11.46-194.159-29.307c-173.084-27.483-298.712,28.551-353.679,10.378 C2602.818,2201.429,2663.062,2170.203,2710.571,2166.485z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000080898878014039914130000011892351007084151740_",
    gradientUnits: "userSpaceOnUse",
    x1: -1096.3456,
    y1: 1661.8048,
    x2: -839.3914,
    y2: 2894.0957,
    gradientTransform: "matrix(-1 0 0 1 1961.1639 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000080898878014039914130000011892351007084151740_)"
    },
    d: "M2912.114,1507.121 c37.496-30.81,112.892,4.066,133.046,13.388c112.391,51.988,213.302,192.08,188.299,340.129 c-3.749,22.204-21.138,126.058-109.079,176.38c-79.349,45.405-186.494,33.727-272.341-30.582 c-11.731-10.411-23.465-20.819-35.197-31.229c-11.541-12.475-23.086-24.951-34.627-37.428 c18.143-15.092,48.971-36.863,92.266-50.833c57.081-18.419,98.638,14.631,125.122-10.496 c18.278-17.341,18.319-47.97,13.806-66.532c-9.098-37.413-42.077-47.934-69.604-74.489 C2879.133,1673.04,2867.218,1544.011,2912.114,1507.121z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000142148307401369003860000008766522219911104958_",
    gradientUnits: "userSpaceOnUse",
    x1: -588.7271,
    y1: 2198.2209,
    x2: -649.5255,
    y2: 2025.9585,
    gradientTransform: "matrix(-1 0 0 1 1961.1639 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#311944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#893976"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000142148307401369003860000008766522219911104958_)"
    },
    points: "2373.253,1990.436  2875.849,1982.933 2742.2,2047.433 2371.968,2023.202  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000052787438987234512990000007951178459379130000_",
    gradientUnits: "userSpaceOnUse",
    x1: -854.3283,
    y1: 1948.6392,
    x2: -832.0356,
    y2: 2102.6621,
    gradientTransform: "matrix(-1 0 0 1 1961.1639 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#311944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#893976"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000052787438987234512990000007951178459379130000_)"
    },
    d: "M2893.586,1996.289v0.002 c0,9.405-5.886,17.807-14.725,21.022l-160.596,62.958l-0.731-43.648l158.315-53.691 C2884.732,1980.379,2893.586,1987.047,2893.586,1996.289z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000046305742258018938190000011342446276613437873_",
    gradientUnits: "userSpaceOnUse",
    x1: 2690.5493,
    y1: 1972.8165,
    x2: 2816.5422,
    y2: 1972.8165
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000046305742258018938190000011342446276613437873_)"
    },
    d: "M2816.195,1966.551 c3.084-0.689-15.027-36.777-29.246-32.613c-14.216,4.166-83.757,44.467-90.078,61.062c-6.322,16.594-6.322,16.594-6.322,16.594 s30.335,2.371,49.147-3.95C2758.51,2001.322,2791.112,1972.143,2816.195,1966.551z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000113324994861991755610000014218413197782507437_",
    gradientUnits: "userSpaceOnUse",
    x1: -412.6077,
    y1: 1962.1294,
    x2: -531.1426,
    y2: 1793.8099,
    gradientTransform: "matrix(-1 0 0 1 1961.1639 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#26264F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000113324994861991755610000014218413197782507437_)"
    },
    d: "M2704.2,1730.373l35.427,322.563 c1.222,11.13-14.359,27.712-25.544,27.183l-519.71-31.905c-8.54-0.406-15.651-6.691-17.096-15.117l-65.231-311.54 c-1.946-11.337,18.434-23.046,29.933-22.725l544.623,15.314C2695.698,1714.403,2703.208,1721.327,2704.2,1730.373z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000042731314386291133550000015339409303576067719_",
    gradientUnits: "userSpaceOnUse",
    x1: -639.9789,
    y1: 2240.6951,
    x2: -380.571,
    y2: 1713.7734,
    gradientTransform: "matrix(-1 0 0 1 1961.1639 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#311944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#893976"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000042731314386291133550000015339409303576067719_)"
    },
    d: "M2692.323,1739.777l35.428,322.567 c1.222,11.13-7.789,20.718-18.973,20.191l-526.283-24.915c-8.538-0.405-15.649-6.691-17.096-15.116l-53.768-312.965 c-1.947-11.34,6.97-21.624,18.469-21.3l544.624,15.314C2683.818,1723.806,2691.332,1730.734,2692.323,1739.777z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000004529569041257271670000003269520041067045508_",
    gradientUnits: "userSpaceOnUse",
    x1: -766.6973,
    y1: 1902.4993,
    x2: -196.8146,
    y2: 1902.4993,
    gradientTransform: "matrix(-1 0 0 1 1961.1639 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#311944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#893976"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "url(#SVGID_00000004529569041257271670000003269520041067045508_)"
    },
    d: "M2383.29,1982.034 c45.953-19.476,29.734-56.618,83.999-102.899c71.587-61.055,144.555-34.576,170.099-81.899 c7.955-14.74,11.754-37.673-2.102-74.792l39.438,1.109c9.094,0.254,16.608,7.181,17.598,16.224l35.428,322.567 c1.22,11.128-7.791,20.718-18.973,20.191l-526.283-24.915c-8.538-0.405-15.649-6.689-17.096-15.116l-7.42-43.186 c15.968-8.886,35.05-16.966,57.314-21.483C2292.503,1962.173,2330.385,2004.457,2383.29,1982.034z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000067951443461996500900000005754820353208685206_",
    gradientUnits: "userSpaceOnUse",
    x1: 2149.1255,
    y1: 2037.2649,
    x2: 2234.1238,
    y2: 2037.2649
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000067951443461996500900000005754820353208685206_)"
    },
    d: "M2149.339,2012.502 c-0.856-2.598,0.958-5.275,3.691-5.414c11.123-0.567,36.92-0.798,51.162,7.924c18.5,11.332,42.422,32.011,22.277,42.445 l-18.811,9.746c-0.864,0.448-1.805,0.586-2.753,0.379c-6.684-1.47-34.817-7.711-37.894-9.261 C2164.211,2056.91,2153.484,2025.078,2149.339,2012.502z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000157283986628342275370000007758071231017148573_",
    gradientUnits: "userSpaceOnUse",
    x1: 2792.9451,
    y1: 1345.5038,
    x2: 2771.2126,
    y2: 1714.9509
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000157283986628342275370000007758071231017148573_)"
    },
    d: "M2787.502,1345.184 c-0.281,33.454,3.451,59.986,6.982,78.155c4.044,20.818,6.959,26.196,10.678,30.56c5.598,6.569,14.083,12.079,62.021,23.967 c26.087,6.467,29.443,6.291,30.02,8.88c2.81,12.629-68.325,55.67-141.816,45.296c-44.978-6.348-85.901-32.009-83.389-45.484 c2.529-13.561,47.456-6.285,60.847-30.819c9.315-17.068-1.127-41.298-13.469-61.364 C2731.331,1371.977,2775.548,1367.582,2787.502,1345.184z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000133494723751549683160000009471475823069278621_",
    gradientUnits: "userSpaceOnUse",
    x1: 2911.95,
    y1: 1341.5504,
    x2: 2826.8579,
    y2: 1125.4321,
    gradientTransform: "matrix(1 0.0037 -0.0037 1 -77.8609 162.9159)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#311944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6B3976"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000133494723751549683160000009471475823069278621_)"
    },
    d: "M2704.021,1358.41 c-10.615-14.1-11.27-38.718,0.961-54.278c10.525-13.39,27.089-15.299,37.005-16.446c28.735-3.318,64.99,8.678,77.602,35.124 c7.473,15.673-8.692,48.237-11.223,54.092c-2.867,6.619-8.063,8.89-12.871,13.896c-6.662,6.941-17.093,17.979-34.118,36.438 c-1.323-5.447-3.335-12.19-6.53-19.498c-1.23-2.814-6.17-13.801-13.646-22.912 C2726.227,1366.563,2714.084,1371.773,2704.021,1358.41z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000028317057579918455270000001265568020920011410_",
    gradientUnits: "userSpaceOnUse",
    x1: 2699.093,
    y1: 1390.5465,
    x2: 2808.1135,
    y2: 1390.5465
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000028317057579918455270000001265568020920011410_)"
    },
    d: "M2785.663,1411.713 c0,0-18.89,30.99-56.5,28.544c-33.674-2.192-38.606-77.708-17.098-93.733c7.176-5.346,21.547-7.566,33.232-4.292 c6.901,1.935,9.24,4.802,20.577,7.742c10.46,2.715,13.412,1.555,16.57,4.21c3.948,3.325,6.841,11.472,0.247,33.548 c6.425-6.505,14.136-9.001,19.601-6.421c0.87,0.413,3.183,1.985,4.484,4.369 C2811.484,1394.304,2803.606,1405.321,2785.663,1411.713z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000002344212487987949170000001905123778492098452_",
    gradientUnits: "userSpaceOnUse",
    x1: 2885.9551,
    y1: 1351.8989,
    x2: 2800.7769,
    y2: 1135.5616,
    gradientTransform: "matrix(1 0.0037 -0.0037 1 -77.8609 162.9159)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#311944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6B3976"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000002344212487987949170000001905123778492098452_)"
    },
    d: "M2783.966,1349.668 c-1.624,1.211,3.341,7.27,3.71,15.845c0.721,16.646-16.128,36.626-33.316,38.321c-10.162,1.001-12.955-5.124-29.754-6.899 c-10.401-1.098-19.058,0.224-24.505,1.414c-5.279,18.257-0.312,36.458,11.891,44.903c13.137,9.092,29.919,3.576,36.935,1.27 c4.694-1.543,19.734-6.456,27.595-20.248c8.19-14.373,0.153-23.037,9.549-32.758c4.74-4.904,10.965-7.027,17.025-16.52 c1.646-2.58,2.744-4.861,3.416-6.396C2797.822,1359.393,2786.318,1347.914,2783.966,1349.668z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000146468988672809990180000014559499902523563393_",
    gradientUnits: "userSpaceOnUse",
    x1: 2709.5762,
    y1: 1409.2805,
    x2: 2733.5359,
    y2: 1409.2805
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000146468988672809990180000014559499902523563393_)"
    },
    d: "M2712.324,1405.117 c0,0,7.273,3.8,19.84,3.093c0.611-0.036,1.286,0.145,1.364,0.461c0.289,1.192-7.774,6.537-15.203,4.45 c-5.274-1.484-9.378-6.477-8.669-7.749C2709.958,1404.838,2711.15,1404.908,2712.324,1405.117z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnavailable);
export default __webpack_public_path__ + "static/media/unavailable.f696005366b9c0b945b6563f1e48a934.svg";
export { ForwardRef as ReactComponent };